import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import config from "../config";
import { Auth, Hub } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import { signOut } from "../modules/auth";
import VpdEventBus from "../modules/vpd-event-bus";
import Accounts from "../views/Accounts.vue";
import ServicesTermsAndConditions from "../views/ServicesTermsAndConditions.vue";
import Login from "../views/Login.vue";
import Registration from "../views/Registration.vue";
import Activation from "../views/Activation.vue";
import ResetPass from "../views/ResetPass.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import Callback from "../views/Callback.vue";
import Page404 from "../views/404.vue";
import CookiePolicy from "../views/CookiePolicy.vue";
import Confirmation from "../views/Confirmation.vue";
import Consents from "../views/Confirmation.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    name: "home",
    props: { config },
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "defaultPath ",
        redirect: "accounts",
        props: { config },
      },
      {
        path: "accounts",
        name: "accounts",
        component: Accounts,
        props: { config },
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/oauth/callback/:bank",
    name: "oauth-handler",
    component: Callback,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      to.meta.props = {
        to: to,
      };
      next();
    },
  },
  {
    path: "/services-terms-and-conditions",
    name: "services-terms-and-conditions",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ServicesTermsAndConditions,
    props: { config },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    props: { config },
    meta: { authEntry: true },
  },
  {
    path: "/logout",
    name: "logout",
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      await signOut();
      next({ name: "home" });
    },
  },
  {
    path: "/reset-pass",
    name: "resetPass",
    component: ResetPass,
    props: { config },
  },
  {
    path: "/registration",
    name: "registration",
    component: Registration,
    props: { config },
    meta: { authEntry: true },
  },
  {
    path: "/activation",
    name: "activation",
    component: Activation,
    props: { config },
    meta: { authEntry: true },
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy,
    props: { config },
  },
  {
    path: "/cookie-policy",
    name: "cookie-policy",
    component: CookiePolicy,
    props: { config },
  },
  {
    path: "/confirmation",
    name: "confirmation",
    component: Confirmation,
    props: {
      header: true,
      content: true
   }, 
  },
  {
    path: "/banks/:id",
    name: "invidual-banks",
    component: Consents,
    props: { config },
    meta: { requiresAuth: true },
  },
  {
    path: "*",
    name: "404",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'auto' });
}
});

const redirects = {
  signedOut: () => {
    router.push({ path: "login" }).catch(() => {});
  },
  signUp: () => {
    router.push({ path: "registration" }).catch(() => {});
  },
  confirmSignUp: () => {
    router.push({ name: "confirm" }).catch(() => {});
  },
  signIn: () => {
    router.push({ name: "login" }).catch(() => {});
  },
  signedIn: () => {
    const path = router.app.$route.query.redirect || "/";
    router.push({ path }).catch(() => {});
  },
  forgotPassword: () => {
    router.push({ name: "confirmNewpass" }).catch(() => {});
  },
  signIn_failure: () => {
  },
};

AmplifyEventBus.$on("authState", async (state) => {
  if (typeof redirects[state] === "function") {
    router.app.$store.dispatch("general/userState", state);
    redirects[state]();
  }
});

VpdEventBus.$on("redirect", async (data) => {
  const entry = `redirect_${data.name}`;
  if (typeof redirects[entry] === "function") {
    redirects[entry](data.payload);
  }
});

Hub.listen("auth", (data) => {
  const state = data.payload.event;

  switch (state) {
    case "signIn":
      AmplifyEventBus.$emit("authState", "signedIn");
      break;
    case "signIn_failure":
      break;
    case "tokenRefresh_failure":
      break;
    default:
      break;
  }
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (user && user.signInUserSession) {
          router.app.$store.dispatch("general/userState", "signedIn");
        }
        next();
      })
      .catch(() => {
        next({
          name: "login",
          query: {
            redirect: to.fullPath,
          },
        });
      });
  }
  next();
});

export default router;
